import React from 'react'
import { useTranslation } from 'react-i18next';

export const LoadMoreButton = ({ handleLoadMore }) => {
    const { t } = useTranslation();

    const onLoadMore = () => {
        if (handleLoadMore) {
            handleLoadMore();
        }
    }

    return (
        <button className="btn btn-transparent text-light mx-auto my-2 d-flex"
            onClick={onLoadMore}>
            <span style={{ borderBottom: '1px solid #e7eaf3' }}>{t('Load More')}</span>
        </button>
    )
}
